import { useEffect, useMemo } from 'react';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import { getCleanedUrlParams, showError } from '@utils';
import { sellVehiclesB2BServices, vehiclesServices } from '@services';
import { FILTER_RULE_ENUMS, LIMIT } from '@constants';
import { QUERY_KEYS } from 'constants/queryKeys';
import { normalizeData, handleEnums } from './utils';

export const SELL_VEHICLES_B2B_PAGE_SIZE = LIMIT;
const EMPTY_RULE = {
  type: FILTER_RULE_ENUMS.EmptyRuleType,
};

export const useSellVehiclesB2BOperations = (enableFetch = true) => {
  const router = useRouter();

  const page = router.query?.page || 1;
  const pageSize = router.query?.pageSize || SELL_VEHICLES_B2B_PAGE_SIZE;
  const order = router.query?.order || 'desc';
  const orderBy = router.query?.orderBy || 'createdAt';
  const params = getCleanedUrlParams({
    orderBy,
    order,
    page,
    pageSize: parseInt(pageSize, 10) || SELL_VEHICLES_B2B_PAGE_SIZE,
  });
  const { data: enumsData, isFetched: enumsFetched } = useQuery(
    [QUERY_KEYS.GET_ENUMS_KEY],
    () => vehiclesServices?.getVehiclesEnums()
  );

  const enums = useMemo(() => handleEnums(enumsData?.data), [enumsData]);

  const sellVehiclesB2BResponse = useQuery(
    [QUERY_KEYS.GET_SELL_VEHICLES_B2B_KEY, { orderBy, order, page, pageSize }],
    () =>
      sellVehiclesB2BServices.getSellVehiclesB2B({
        params,
        payload: EMPTY_RULE,
      }),
    { enabled: enableFetch && enumsFetched, refetchOnMount: true }
  );
  const data = normalizeData({
    data: sellVehiclesB2BResponse?.data?.data || [],
    enums,
  });

  useEffect(() => {
    if (sellVehiclesB2BResponse.isError) {
      showError(sellVehiclesB2BResponse?.error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sellVehiclesB2BResponse.isError]);

  return {
    page,
    pageSize: parseInt(pageSize, 10) || SELL_VEHICLES_B2B_PAGE_SIZE,
    total: sellVehiclesB2BResponse?.data?.meta?.total,
    loading: sellVehiclesB2BResponse?.isFetching,
    data,
    enums,
    refetch: sellVehiclesB2BResponse.refetch,
  };
};
